query PurchaseOrderStampPrivileges{

purchaseOrderStampPrivileges {
    isStampingAllowed
  }
}